import Immutable from 'immutable';
import {
  GET_EXCHANGE_RATES,
  CLEAR_EXCHANGE_RATES,
  FLAG_GETTING_EXCHANGE_RATE,
  GET_EXCHANGE_RATE,
  CLEAR_EXCHANGE_RATE,
  FLAG_GETTING_EXCHANGE_RATES,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_EXCHANGE_RATES:
          return state.setIn(['all', 'loading'], action.payload);
    case GET_EXCHANGE_RATES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_EXCHANGE_RATES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_EXCHANGE_RATE:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_EXCHANGE_RATE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_EXCHANGE_RATE:
            return state.setIn(['current'], INITIAL_STATE.getIn(['current']));

    default:
      return state;
  }
};
